import { pure } from '@core/helpers/pure';
import { TuiTextarea } from '@taiga-ui/kit';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import {
  TuiDialogContext,
  TuiError,
  TuiButton,
  TuiTextfield,
} from '@taiga-ui/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Nullable } from '@core/helpers/nullable';
import { RequestStatusChangeReasonForm } from '../../types';
import { POLYMORPHEUS_CONTEXT } from '@taiga-ui/polymorpheus';
import { TranslatePipe } from '@ngx-translate/core';

enum FormFields {
  Reason = 'reason',
}
@Component({
  selector: 'x-request-form-status-edit-reason',
  imports: [
    TuiTextfield,
    TuiTextarea,
    TuiError,
    TuiButton,
    ReactiveFormsModule,
    TranslatePipe,
  ],
  templateUrl: './request-form-status-edit-reason.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestFormStatusEditReasonComponent {
  private readonly context =
    inject<TuiDialogContext<Nullable<RequestStatusChangeReasonForm>>>(
      POLYMORPHEUS_CONTEXT,
    );

  readonly formGroup = new FormGroup({
    [FormFields.Reason]: new FormControl<Nullable<string>>(null, [
      Validators.required,
      Validators.maxLength(10_000),
    ]),
  });
  readonly FormFields = FormFields;

  @pure
  get reasonField() {
    return this.formGroup.get(FormFields.Reason);
  }

  submit() {
    this.context.completeWith(this.formGroup.getRawValue());
  }

  dismiss() {
    this.context.completeWith(null);
  }
}
